import React from "react";

import { createRoot } from "react-dom/client";
import App from "./App";
import * as Sentry from "@sentry/react";

// Sentry.init({
//     dsn: "", // {TODO} - Indicate the dsn URL given by Sentry for React
//     // Setting this option to true will send default PII data to Sentry.
//     // For example, automatic IP address collection on events
//     sendDefaultPii: true
// });

const container = document.getElementById("root") || document.body.appendChild(document.createElement("div"));
const root = createRoot(container);
root.render(<App />);